export enum ZPrinterFiscalConfigPaymentAmountExchangeType {
  pos = 'pos',
  cashManagement = 'cashmanagement',
  alternative = 'alternative',
  foodStamp = 'foodstamp',
  voucher = 'voucher',
  manual = 'manual',
}
